<!-- HTML -->
<template> 
    <div class="drag-body"  :class="currLayoutData.area_style.color">
        <template v-if="currLayoutData.direction != 2">
            <div v-if="isPreview" class="drag-area-title" style="font-size: var(--col-text-font)">{{currLayoutData.area_name}}</div>
            <input v-else class="drag-area-title" style="font-size: var(--col-text-font)" type="text"  @change="changeLayoutData($event,'area_name')" v-model="currLayoutData.area_name" />
        </template>    
        <div v-for="(item,row_index) in currLayoutData.seat_list" :key="'a'+item.row_id" class="drag-area-row">
            <!-- <input class="row-title" type="text" @change="changeLayoutData('row_name',{row_name:item.row_name})" v-model="item.row_name"> -->
            <!-- 筛选模式时  selection-highlight为选中高亮样式 -->
            <div v-for="(col,col_index) in item.col" :key="item.row_id+'_'+col_index" class="drag-area-col drag-area-col-border" :style="filterSeatFun(col.seat_item)|calcAreaColSize">
                <div class="desk-info" style="font-size: var(--col-text-font)">
                    <template v-if="isPreview">
                        <div v-if="currLayoutData.seat_list.length == 1 && item.col.length == 1" class="display-block col-title">{{currLayoutData.area_name}}</div>
                        <div v-else class="display-block col-title">{{(item.row_name+col.desk_name).replace('号','桌')}}</div>
                    </template>
                    <template v-else>
                        <input v-if="currLayoutData.seat_list.length == 1 && item.col.length == 1" class="display-block col-title" type="text" @change="changeLayoutData($event,'area_name')" v-model="currLayoutData.area_name">
                        <input v-else class="display-block col-title" type="text" disabled @change="changeLayoutData($event,'area_name')" :value="(item.row_name+col.desk_name).replace('号','桌')">
                        <!-- <input class="display-inline-block col-title text-align-right" type="text" @change="changeLayoutData($event,'row_name',{row_id:item.row_id})" v-model="item.row_name"> -->
                        <!-- <input class="display-inline-block col-title text-align-left" type="text" @change="changeLayoutData($event,'desk_name',{row_id:item.row_id,desk_id:col.desk_id})" v-model="col.desk_name"> -->
                    </template>
                    
                </div>
                <template v-for="(seat,seat_index) in calcRotateAngle({layout_index:layoutIndex,row_index,col_index},col.seat_item)">
                    <div class="seat-item-box" v-if="seat.is_valid == '1' || isShowInvalidSeat" :key="'c'+seat.seat_id" :style="seat.seat_style" :class="setSelectionEl(seat)" :ref="seat.person|setSelectionElRef">
                        <div
                        style="widht:var(--seat-item-width);height:var(--seat-item-height);"
                        class="col-text" 
                        draggable="true" 
                        :layout-index="layoutIndex"
                        :row-index="row_index"
                        :col-index="col_index"
                        :seat-index="seat_index"
                        :is-valid="seat.is_valid"
                        @dragstart="handleDragStart" 
                        @dragover.prevent="handleDragOver"
                        @dragenter="handleDragEnter" 
                        @dragend="handleDragEnd"
                        @click="handleClickSeatEvent($event,'click',currLayoutData.area_id,item.row_id,col.desk_id,seat.seat_id)"
                        @contextmenu.prevent="handleClickSeatEvent($event,'contextmenu',currLayoutData.area_id,item.row_id,col.desk_id,seat.seat_id)" 
                        :class="{'empty' : !seat.person,'is_valid' : (isShowInvalidSeat && seat.is_valid == '0'),}">
                            <!-- 圆桌不处理 class="js-content-text" -->
                            <span style="font-size:var(--seat-item-font);" v-if="(seat.person||{}).name">{{(seat.person || {}).name}}</span> 
                            <!-- <span style="color:#000">{{seat.seat_id}}</span> -->
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <template  v-if="currLayoutData.direction == 2">
            <div v-if="isPreview" class="drag-area-title" style="font-size: var(--col-text-font)">{{currLayoutData.area_name}}</div>
            <input class="drag-area-title" style="font-size: var(--col-text-font)" type="text" @change="changeLayoutData($event,'area_name')" v-model="currLayoutData.area_name" />
        </template>    
    </div>
</template>

<!-- js脚本 -->
<script>
import areaMin from './area-mixin';
import dragMin from '@/components/drag-mixin';
import { mapState } from 'vuex'
export default {
    mixins: [areaMin,dragMin],
    isPreview:{
        type:Boolean,
        default:false,
    },
    filters: {
        calcAreaColSize(m) {
            /* 抄袭老版本算法：
             *    1、m为每桌座位数
             *    2、直径 = 周长/π;
             *    3、常量70（老版本为80）为座位宽度+外边距
             *    4、默认值最小为200（老版本为300）
             */
            let R = 70 * m / Math.PI;
            R = (R < 200) ? 200 : R;
            return `width:${R}px;height:${R}px;`
        }
    },
    methods: {
        // 过滤隐藏座位
        filterSeatFun (list) {
            if (this.isShowInvalidSeat) {
                return list.length
            } else {
                const valid = list.filter(item => item.is_valid == 1)
                return valid.length
            }
        },
        calcRotateAngle(indexObj,arr) {
            /** 计算每个座位的旋转角度
             *    1、m为当前有效桌位总数
             *    2、angle=360/m  得出每个座位的角度
             *    3、radian=angle/180*π 角度转换为对应的弧度
             *    4、三角函数得出top和left值
             *    5、计算半径
             */
            let m = 0;
            for (let i = 0, l = arr.length; i < l; i++) {
                if (this.isShowInvalidSeat) { //是否显示无效座位
                    m++
                } else {
                    (arr[i].is_valid == '1') && m++;
                }
            }
            const radian = 2 / m * Math.PI; // 每个座位的弧度
            let R = 70 * m / Math.PI;
            R = (R < 200) ? 200 : R; // 得到直径
            let r = R / 2;  //  得到半径
            /* ----------------------------------- */
            // 格式化数据
            let result = []
            m = 0;
            for (let i = 0, l = arr.length; i < l; i++) {
                const item = arr[i];
                let style = `top:0px;left:0px`;
                if (item.is_valid == '1' || this.isShowInvalidSeat) {
                    style = `top:${Math.cos(radian * m) * r + r}px;left:${Math.sin(radian * m) * r + r}px`;
                    m++;
                }
                result.push({ ...item, seat_style: style });
            }
            return result;
        }
    }
};
</script>

<!-- css样式 -->
<style lang="less" scoped>
@import url('~@/assets/css/area-content.less');
.drag-body {
    .drag-area-title {
        margin-bottom: 30px;
    }
    .drag-area-row {
        margin-bottom: 40px;
        & + .drag-area-row {
            margin-top: 80px;
        }
    }
    .row-title {
        vertical-align: top;
    }
    .drag-area-col {
        border: 2px solid #ddd;
        border-radius: 100%;
        margin: 0 40px;
        position: relative;
    }
    .desk-info {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        z-index: 0;
        transform: translateY(-50%);
        text-align: center;
        .display-block {
            display: block;
            width: 110px;
            margin: auto;
        }
        .display-inline-block {
            display: inline-block;
            width: 50px;
            margin: 0 5px;
        }
        .text-align-right {
            text-align: right;
        }
        .text-align-left {
            text-align: left;
        }
    }
    .seat-item-box {
        width: 60px;
        // height: 22px;
        height: auto;
        position: absolute;
        z-index: 1;
        transform: translate(-50%, -50%);
        .col-text {
            border-radius: 44px;
        }
    }
}
</style>